import { __exports as e } from "./index.es73.js";
import { d as p } from "./index.es26.js";
var g;
function b() {
  if (g) return e;
  g = 1;
  var _ = p, i = e.isTag = _.isTag;
  e.testElement = function(r, t) {
    for (var n in r)
      if (r.hasOwnProperty(n)) {
        if (n === "tag_name") {
          if (!i(t) || !r.tag_name(t.name))
            return !1;
        } else if (n === "tag_type") {
          if (!r.tag_type(t.type)) return !1;
        } else if (n === "tag_contains") {
          if (i(t) || !r.tag_contains(t.data))
            return !1;
        } else if (!t.attribs || !r[n](t.attribs[n]))
          return !1;
      }
    return !0;
  };
  var f = {
    tag_name: function(r) {
      return typeof r == "function" ? function(t) {
        return i(t) && r(t.name);
      } : r === "*" ? i : function(t) {
        return i(t) && t.name === r;
      };
    },
    tag_type: function(r) {
      return typeof r == "function" ? function(t) {
        return r(t.type);
      } : function(t) {
        return t.type === r;
      };
    },
    tag_contains: function(r) {
      return typeof r == "function" ? function(t) {
        return !i(t) && r(t.data);
      } : function(t) {
        return !i(t) && t.data === r;
      };
    }
  };
  function s(r, t) {
    return typeof t == "function" ? function(n) {
      return n.attribs && t(n.attribs[r]);
    } : function(n) {
      return n.attribs && n.attribs[r] === t;
    };
  }
  function y(r, t) {
    return function(n) {
      return r(n) || t(n);
    };
  }
  return e.getElements = function(r, t, n, u) {
    var c = Object.keys(r).map(function(a) {
      var o = r[a];
      return a in f ? f[a](o) : s(a, o);
    });
    return c.length === 0 ? [] : this.filter(
      c.reduce(y),
      t,
      n,
      u
    );
  }, e.getElementById = function(r, t, n) {
    return Array.isArray(t) || (t = [t]), this.findOne(s("id", r), t, n !== !1);
  }, e.getElementsByTagName = function(r, t, n, u) {
    return this.filter(f.tag_name(r), t, n, u);
  }, e.getElementsByTagType = function(r, t, n, u) {
    return this.filter(f.tag_type(r), t, n, u);
  }, e;
}
export {
  b as __require
};
//# sourceMappingURL=index.es54.js.map
